import $ from 'jquery';

import './style.scss';

function attachExpander(table) {
  const $table = $(table);
  const $expander = $table.find('.js-comparison-table__expander');
  const setArrowIcon = icon => (`<path d='${icon[0]}'/><path d='${icon[1]}' fill="none"/>`);
  const arrowIconUp = ['M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z', 'M0 0h24v24H0z'];
  const arrowIconDown = ['M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z', 'M0-.75h24v24H0z'];
  const trackActions = [
    '.js-accordion-to-tabs__button',
    '.js-comparison-table__review a',
    '.js-comparison-table__goToSite a',
  ];

  function callAjax($expanderCTA, niche, site, origin, id, tableId, redirectTrackingParams) {
    const ajaxData = {
      action: 'get_expander_ajax',
      niche,
      site,
      origin,
      id,
      tableId,
      redirectTrackingParams,
    };
    $.post(window.wpajax.ajaxurl, ajaxData)
      .done((response) => {
        // Replaces default html (Fetching your data)
        const $contentWrapper = getContentWrapperElement($expanderCTA);
        $contentWrapper.html(response);
        $contentWrapper.find('[rel="popover"]').trigger('loadpopover');
        $contentWrapper.trigger('expanderContentLoaded');
      });
  }

  function getContentWrapperElement($expanderCTA) {
    const $cellWrapper = $expanderCTA.find('.comparison-table__cellWrapper');

    return $cellWrapper.length === 1
      ? $cellWrapper
      : $expanderCTA;
  }

  $table.on('click', '.js-comparison-table__view-details-button', function deleteCallback(e) {
    e.preventDefault();
    const $row = $(this).closest('tr');
    const $expanderCTA = $row.find('.js-comparison-table__expander');
    const $expanderIcon = $(this).find('.luna-icon');
    const $detailsBtnText = $(this).find('span');

    if ($expanderCTA.attr('aria-hidden') === 'false') {
      // Closes Expander
      $detailsBtnText.text('View details ');
      $expanderCTA.attr('aria-hidden', true).slideUp('fast');
      $expanderIcon.html(setArrowIcon(arrowIconDown));
    } else {
      // Opens expander
      $detailsBtnText.text('Hide details ');
      const $form = $(table).parent('form[name="compareForm"]');
      $expanderCTA.addClass('show').removeClass('hide').attr('aria-hidden', false);
      $expanderCTA.slideDown('fast');
      $expanderIcon.html(setArrowIcon(arrowIconUp));

      const $tableId = $form.attr('data-table-id') ? $form.attr('data-table-id') : null;
      callAjax(
        $expanderCTA,
        $form.data('niche'),
        $form.data('site'),
        $form.data('origin'),
        $row.data('product-id'),
        $tableId,
        $form.data('redirect-tracking-params'),
      );
    }
  });

  // Track Expander tabs and action buttons (go to site and full review link)
  $expander.on('click', trackActions.join(', '), function callback() {
    const $this = $(this);
    $.trackEvent(
      'Table expander',
      $this.closest('tr').find('.comparison-table__name a').text(),
      $this.data('track-action'),
      0,
      true,
    );
  });

  $table.on('click', '.luna-tab', function openTabCallback() {
    const $tabs = $table.find('.luna-tab');
    const $tabContents = $(this).closest('tr').find('.luna-tabs__content');
    const $selectedContentSelector = `.luna-tabpanel[aria-labelledby="${$(this).attr('aria-controls')}"]`;

    // set all tabs to not selected
    $tabs.attr('aria-selected', false);
    // set all content to hidden
    $tabContents.find('.luna-tabpanel').attr('aria-hidden', true);
    // set current tab to selected
    $(this).attr('aria-selected', true);
    // set current tab's content visible
    $tabContents.find($selectedContentSelector).attr('aria-hidden', false);
  });
}

export default attachExpander;
